export const getFnbPriceChanges = async (data, thunkApi) => {
  try {
    const { user } = thunkApi.extra.apiService;
    const { limit, offset, sort, month, year } = data;
    const params = {
      limit,
      offset,
      sort,
    };
    
    if (month) params.month = month;
    if (year) params.year = year;
    
    const response = await user.get("/fnbproduct/price-change", {
      params,
    });

    return response;
  } catch (error) {
    return new Promise.reject(error);
  }
};
